module.exports = __webpack_public_path__ + "static/media/aurion-logo-candies.27e02598.png";